"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const styles_1 = require("./styles");
const Detalhes = () => {
    return (react_1.default.createElement(styles_1.DetalhesContainer, { item: true, container: true, xs: 6, alignItems: "center" },
        react_1.default.createElement(core_1.Container, { maxWidth: "sm" },
            react_1.default.createElement(core_1.Grid, { container: true },
                react_1.default.createElement(core_1.Grid, { item: true, container: true, direction: "column", justify: "center", xs: 12, md: 6 },
                    react_1.default.createElement("h1", null, "Gente impulsionando gente"),
                    react_1.default.createElement("p", null, "Simule e compare!"))))));
};
exports.default = Detalhes;
//# sourceMappingURL=index.js.map